/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import MobileSelectModal from 'components/MobileSelectModal';
import useMenuRedirect from '../../hooks/useMenuRedirect';
import './style.scss';
import { useVerifyIsMobile } from '../../../../hooks/useVerifyIsMobile';

const DropDown = () => {
  const { getNodesDropDown, handleRedirect, nodesSelected } = useMenuRedirect();
  const { isMobile } = useVerifyIsMobile(768);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState(nodesSelected?.childs?.[0]?.text);
  const toogleMenu = () => {
    setVisible(prev => !prev);
  };

  const handleChangeOption = e => {
    const node = nodesSelected.childs.filter(
      n => n.code === e.target.getAttribute('data-value'),
    );
    setSelected(node?.[0]?.text);
    handleRedirect({ node: node[0] });
  };

  return (
    <>
      {isMobile ? (
        <MobileSelectModal
          selected={selected}
          show={visible}
          setShow={setVisible}
          position="start"
        >
          {getNodesDropDown().map(item => (
            <li
              data-id={item.id}
              data-value={item.value}
              key={item.id}
              onClick={handleChangeOption}
            >
              {item.label}
            </li>
          ))}
        </MobileSelectModal>
      ) : (
        <div className="dropdown-select">
          <button
            type="button"
            className="dropdown-select__button"
            onClick={toogleMenu}
          >
            {selected} <FaChevronDown size={14} />
          </button>
          {visible && (
            <div className="dropdown-select__options">
              <ul>
                {getNodesDropDown().map(item => (
                  <li
                    data-id={item.id}
                    data-value={item.value}
                    key={item.id}
                    onClick={handleChangeOption}
                  >
                    {item.label}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </>
  );
};

DropDown.propTypes = {};

export default DropDown;
